import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

export class GitPullGitError extends GitError {
  constructor(message: string) {
    super(message);
  }

  readonly gitErrorCode = GitErrorStatusCode.GitPull;
}
